import { Permission, PermissionValue } from "../public-api";

export interface AddRole {
  role_name: string;
  description: string;
  permission: string[];
  role_id?: string;
}

export interface RoleDetail {
  addedOn: string | Date;
  description: string;
  permissions: string;
  role_id: string;
  role_name: string;
  can_Create: boolean;
  can_approve: boolean;
  can_support: boolean;
  can_view: boolean;
  permissionsDisplay: string;
  permissionsJson: any;
}
